export default __webpack_public_path__ + "static/media/6.a569d088.jpg";